// operation types
export const SET_DATA = 'SET_DATA';
export const SET_PRODUCTS_DATA = 'SET_PRODUCTS_DATA';
export const SET_DEALERS_DATA = 'SET_DEALERS_DATA';
export const SET_CITIES_DATA = 'SET_CITIES_DATA';
export const SET_COLORS_DATA = 'SET_COLORS_DATA';
export const SET_DOORS_DATA = 'SET_DOORS_DATA';
export const SET_CYLINDERS_DATA = 'SET_CYLINDERS_DATA';
export const SET_FUELTYPE_DATA = 'SET_FUELTYPE_DATA';
export const SET_WARRANTY_DATA = 'SET_WARRANTY_DATA';
export const SET_STEERINGTYPE_DATA = 'SET_STEERINGTYPE_DATA';
export const SET_TRANSMISSION_DATA = 'SET_TRANSMISSION_DATA';
export const SET_HP_DATA = 'SET_HP_DATA';
export const SET_BODY_CONDITION_DATA = 'SET_BODY_CONDITION_DATA';
export const SET_MECH_CONDITION_DATA = 'SET_MECH_CONDITION_DATA';
export const SET_BODY_TYPE_DATA = 'SET_BODY_TYPE_DATA';
export const SET_REG_SPEC_DATA = 'SET_REG_SPEC_DATA';
export const SET_CAR_TRIM_DATA = 'SET_CAR_TRIM_DATA';
export const SET_LOGIN_USER_DATA = 'SET_LOGIN_USER_DATA';

// auth types
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE';
export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGOUT = 'USER_LOGOUT';
export const SAVE_LANGUAGE = 'SAVE_LANGUAGE';
export const LOAD_ORGANIZATION_DATA_STATUS = 'LOAD_ORGANIZATION_DATA_STATUS';
export const LOAD_SALES_ORG_DETAILS = 'LOAD_SALES_ORG_DETAILS';
export const SELECT_SALES_ORG = 'SELECT_SALES_ORG';
export const SHOW_HIDE_SALES_ORG_DIALOG = 'SHOW_HIDE_SALES_ORG_DIALOG';
export const LOAD_MATERIAL_GROUP_FILTERED_DATA = 'LOAD_MATERIAL_GROUP_FILTERED_DATA';
export const LOAD_MATERIAL_GROUP_FILTERED_DATA_STATUS = 'LOAD_MATERIAL_GROUP_FILTERED_DATA_STATUS';
export const LOAD_CUSTOMER_MASTER_DATA = 'LOAD_CUSTOMER_MASTER_DATA';
export const CHECK_SECURE_CONNECTION_STATUS = 'CHECK_SECURE_CONNECTION_STATUS';
export const CHECK_SECURE_CONNECTION = 'CHECK_SECURE_CONNECTION';

// user types
export const SET_USER_DATA = 'SET_USER_DATA';
export const RESET_USER_DATA = 'RESET_USER_DATA';

// alert types
export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';

// item list types
export const GET_ITEM_LIST_DATA = 'GET_ITEM_LIST_DATA';
export const RESET_ITEM_TABLE_LIST_DATA = 'RESET_ITEM_TABLE_LIST_DATA';
export const SAVE_ITEM_LIST_DATA = 'SAVE_ITEM_LIST_DATA';
export const SET_NEW_DATA = 'SET_NEW_DATA';

// item types
export const GET_ITEM_DATA = 'GET_ITEM_DATA';
export const RESET_ITEM_DATA = 'RESET_ITEM_DATA';
export const SET_ITEM_STATUS = 'SET_ITEM_STATUS';
export const SET_LIST_STATUS = 'SET_LIST_STATUS';

// cart types
export const UPDATE_CART = 'UPDATE_CART';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const CLEAR_CART = 'CLEAR_CART';

// favourite types
export const UPDATE_FAVOURITE = 'UPDATE_FAVOURITE';
export const REMOVE_FAVOURITE_ITEM = 'REMOVE_FAVOURITE_ITEM';
export const CLEAR_FAVOURITE = 'CLEAR_FAVOURITE';
export const SET_FAVOURITE_STATUS = 'SET_FAVOURITE_STATUS';
export const SET_ADD_REMOVE_FAVOURITE_STATUS = 'SET_ADD_REMOVE_FAVOURITE_STATUS';
export const LOAD_FAVOURITE_DATA = 'LOAD_FAVOURITE_DATA';

// checkout types
export const GET_USER_DATA = 'GET_USER_DATA';
export const GET_SHIP_TO_PARTY_DATA = 'GET_SHIP_TO_PARTY_DATA';

// payment types
export const UPDATE_PAYMENT = 'UPDATE_PAYMENT';

// search types
export const GET_SEARCH_RESULTS = 'GET_SEARCH_RESULTS';
export const SET_SEARCH_STATUS = 'SET_SEARCH_STATUS';
export const CHECK_SEARCH_RESULT = 'CHECK_SEARCH_RESULT';
export const CHECK_ALL_SEARCH_RESULT = 'CHECK_ALL_SEARCH_RESULT';
export const UPDATE_SEARCH_QTY = 'UPDATE_SEARCH_QTY';
export const SAVE_VALUES = 'SAVE_VALUES';
export const SAVE_IN_STORE = 'SAVE_IN_STORE';

// complete type
export const POST_COMPLETE_ORDER = 'POST_COMPLETE_ORDER';
export const POST_COMPLETE_ORDER_STATUS = 'POST_COMPLETE_ORDER_STATUS';

// sales_order type
export const GET_SALES_ORDER_DATA = 'GET_SALES_ORDER_DATA';
export const SAVE_DATA = 'SAVE_DATA';
export const SET_ORDER_DETAIL_STATUS = 'SET_ORDER_DETAIL_STATUS';
export const GET_ORDER_DETAIL_DATA = 'GET_ORDER_DETAIL_DATA';

// table data type
export const GET_ORDER_TABLE_DATA = 'GET_ORDER_TABLE_DATA';
export const SET_ORDER_TABLE_STATUS = 'SET_ORDER_TABLE_STATUS';
export const SELECT_ORDER = 'SELECT_ORDER';
export const GET_BILLING_TABLE_DATA = 'GET_BILLING_TABLE_DATA';
export const SET_BILLING_TABLE_STATUS = 'SET_BILLING_TABLE_STATUS';
export const GET_DELIVERY_TABLE_DATA = 'GET_DELIVERY_TABLE_DATA';
export const SET_DELIVERY_TABLE_STATUS = 'SET_DELIVERY_TABLE_STATUS';
export const GET_SHIPPING_TABLE_DATA = 'GET_SHIPPING_TABLE_DATA';
export const SET_SHIPPING_TABLE_STATUS = 'SET_SHIPPING_TABLE_STATUS';
export const GET_MATERIAL_GROUP_TABLE_DATA = 'GET_MATERIAL_GROUP_TABLE_DATA';
export const SET_MATERIAL_GROUP_TABLE_STATUS = 'SET_MATERIAL_GROUP_TABLE_STATUS';

// common types
export const RESET_STATE = 'RESET_STATE';
// language data type
export const UPDATE_USER_PREFERENCE = 'UPDATE_USER_PREFERENCE';

export const SYSTEM_SELECT = 'SYSTEM_SELECT';
export const SET_CART_DATA = 'SET_CART_DATA';
export const SET_CART_STATUS = 'SET_CART_STATUS';

// complaint type
export const SET_ORGANIZATION_DATA = 'SET_ORGANIZATION_DATA';
export const SET_ORGANIZATION_DATA_STATUS = 'SET_ORGANIZATION_DATA_STATUS';

export const SAVE_SETTINGS = 'SAVE_SETTINGS';
export const GET_CUSTOMER_TABLE_DATA = 'GET_CUSTOMER_TABLE_DATA';
export const SET_CUSTOMER_TABLE_STATUS = 'SET_CUSTOMER_TABLE_STATUS';
export const GET_EQUIPMENT_DATA = 'GET_EQUIPMENT_DATA';
export const SET_EQUIPMENT_DATA_STATUS = 'SET_EQUIPMENT_DATA_STATUS';
export const RESET_EQUIPMENT_DATA = 'RESET_EQUIPMENT_DATA';
export const SET_SUBMIT_REQUEST_STATUS = 'SET_SUBMIT_REQUEST_STATUS';

export const SET_UPLOAD_STATUS = 'SET_UPLOAD_STATUS';
export const LOAD_UPLOAD_DATA = 'LOAD_UPLOAD_DATA';

export const SET_QUOTATION_ORDER_DATA = 'SET_QUOTATION_ORDER_DATA';
export const SET_QUOTATION_ORDER_DATA_STATUS = 'SET_QUOTATION_ORDER_DATA_STATUS';
export const SET_QUOTATION_DETAIL_STATUS = 'SET_QUOTATION_DETAIL_STATUS';
export const SELECT_QUOTATION = 'SELECT_QUOTATION';
export const GET_QUOTATION_DETAIL_DATA = 'GET_QUOTATION_DETAIL_DATA';
